import type { UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import type { ITopicPrompts } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sentiment-report/topics-graph/types";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

interface ITopicPromptsParams extends ILLMWidgetRequestParams {
    topic: string;
    maxPromptsPerSentiment: number;
}

export const useSentimentTopicPromptsData = (
    params: ITopicPromptsParams,
    options?: { enabled?: boolean },
): UseQueryResult<ITopicPrompts> =>
    useLLMReportQuery<ITopicPrompts, ITopicPromptsParams>(
        "sentimentTopicPrompts",
        apiClient.AiTracker.aiTrackerReportsSentimentAnalysisPromptsList,
        params,
        options,
    );
